import AttachmentIcon from "@material-ui/icons/Attachment";
import { get } from "lodash";
import React from "react";
import { ShowButton } from "react-admin";

const LogsButton = ({ ...props }) => {
	const logs = get(props, "record.notes");
	if (!logs) {
		return null;
	}
	return <ShowButton icon={<AttachmentIcon />} label="" {...props} />;
};

export default LogsButton;
